"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isBasicUserSubscription = exports.SubscriptionCancelReasonSchema = exports.SubscriptionCancelReasonEnum = exports.SubscriptionStatusSchema = exports.SubscriptionStatusEnum = exports.subscriptionStatuses = void 0;
const zod_1 = require("zod");
const type_validation_helpers_1 = require("../helpers/type_validation_helpers");
const typing_utils_1 = require("../typing_utils");
// CONSTS
exports.subscriptionStatuses = [
    "auto_renewing",
    "future",
    "paused",
    "cancelled",
];
var SubscriptionStatusEnum;
(function (SubscriptionStatusEnum) {
    SubscriptionStatusEnum["AutoRenewing"] = "auto_renewing";
    SubscriptionStatusEnum["Future"] = "future";
    SubscriptionStatusEnum["Paused"] = "paused";
    SubscriptionStatusEnum["Cancelled"] = "cancelled";
})(SubscriptionStatusEnum = exports.SubscriptionStatusEnum || (exports.SubscriptionStatusEnum = {}));
exports.SubscriptionStatusSchema = zod_1.z.union(typing_utils_1.mapArrayToLiteralTuple(exports.subscriptionStatuses));
var SubscriptionCancelReasonEnum;
(function (SubscriptionCancelReasonEnum) {
    SubscriptionCancelReasonEnum["UserCancelled"] = "user_cancelled";
    SubscriptionCancelReasonEnum["BillingIssue"] = "billing_issue";
    SubscriptionCancelReasonEnum["Replaced"] = "replaced";
    SubscriptionCancelReasonEnum["Revoked"] = "revoked";
    SubscriptionCancelReasonEnum["Other"] = "other";
})(SubscriptionCancelReasonEnum = exports.SubscriptionCancelReasonEnum || (exports.SubscriptionCancelReasonEnum = {}));
exports.SubscriptionCancelReasonSchema = zod_1.z.nativeEnum(SubscriptionCancelReasonEnum);
const BasicUserSubscriptionSchema = zod_1.z.object({
    expiresAt: zod_1.z.string().optional(),
    id: zod_1.z.string(),
    nextBillingAt: zod_1.z.string().optional(),
    planId: zod_1.z.string(),
    status: exports.SubscriptionStatusSchema,
    userId: zod_1.z.string(),
});
exports.isBasicUserSubscription = type_validation_helpers_1.getVerboseTypeValidationFunction(BasicUserSubscriptionSchema);
//# sourceMappingURL=subscription_types.js.map